import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";

import { CoreModule } from "./core/core.module";
import { SharedModule } from "./shared/shared.module";
import { ConcessionaireRoutingModule } from "./maintenance-concessionaire/concessionaire-routing.module";
import { MastertablesRoutingModule } from "./maintenance-mastertables/mastertables-routing.module";
import { TemplatesRoutingModule } from "./maintenance-templates/templates-routing.module";
import { MaintenanceUserRoutingModule } from "./maintenance-user/maintenance-user-routing.module";
import { MaintenanceHistoricoBastidorRoutingModule } from "./maintenance-historico-bastidor/maintenance-historico-bastidor-routing.module";
import { ImportDatosAccesoriosRoutingModule } from "./import-datos-accesorios/import-datos-accesorios-routing.module";
import { ExportHistoricoPlacaRoutingModule } from "./export-historico-placa/export-historico-placa-routing.module";
import { PrintFormatsRoutingModule } from "./maintenance-print-formats/print-formats-routing.module";
import { TemplatesRulesRoutingModule } from "./maintenance-templates-rules/templates-rules-routing.module";
import { ReformsRoutingModule } from "./maintenance-reforms/reforms-routing.module";
import { PrintsParamsRoutingModule } from "./maintenance-prints-params/prints-params-routing.module";
import { PrintsRulesRoutingModule } from "./maintenance-prints-rules/prints-rules-routing.module";
import { DataCDTRoutingModule } from "./maintenance-data-cdt/data-cdt-routing.module";
import { RoyalDecreeRoutingModule } from "./maintenance-royal-decree/royal-decree-routing.module";
import { MailBoxRoutingModule } from "./maintenance-mailbox-rules/mailbox-rules-routing.module";
import { ChangePasswordRoutingModule } from "./change-password/change-password-routing.module";
import { CertificatesModule } from "./certificates/certificates.module";
import { PersonalParamsRoutingModule } from "./configuration-personal-params/personal-params-routing.module";
import { CertificatesRoutingModule } from "./certificates/certificates-routing.module";
import { COCRoutingModule } from "./coc/coc-routing.module";
import { DescargaFicheroConcesionarioRoutingModule } from "./descarga-fichero-concesionario/descarga-fichero-routing.module";
import { PatronesWltpRoutingModule } from "./patrones-wltp/patrones-wltp-routing.module";
import { PlacaRoutingModule } from "./placa/placa-routing.module";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { interceptorProvider } from "./core/interceptors/prod-interceptor.service";

import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";

import { CommonModule } from "@angular/common";

// external
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { ToastrModule } from "ngx-toastr";
import { LoginComponent } from "./auth/login/login.component";
import { RegistroComponent } from "./auth/registro/registro.component";
import { IndexComponent } from "./index/index.component";
import { ModalModule } from "./modal/app.modal.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CveComponent } from "./cve/cve.component";
import { RecoveryPasswordComponent } from "./recovery-password/recovery-password.component";
import { HttpSizeInterceptor } from "./core/interceptors/size-http-interceptor";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegistroComponent,
    IndexComponent,
    CveComponent,
    RecoveryPasswordComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    SweetAlert2Module.forRoot(),
    HttpClientModule,
    CKEditorModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule,
    CoreModule,
    SharedModule,
    ConcessionaireRoutingModule,
    MastertablesRoutingModule,
    TemplatesRoutingModule,
    MaintenanceUserRoutingModule,
    MaintenanceHistoricoBastidorRoutingModule,
    ImportDatosAccesoriosRoutingModule,
    ExportHistoricoPlacaRoutingModule,
    DescargaFicheroConcesionarioRoutingModule,
    PatronesWltpRoutingModule,
    PrintFormatsRoutingModule,
    TemplatesRulesRoutingModule,
    ReformsRoutingModule,
    PrintsParamsRoutingModule,
    PrintsRulesRoutingModule,
    DataCDTRoutingModule,
    RoyalDecreeRoutingModule,
    MailBoxRoutingModule,
    ChangePasswordRoutingModule,
    CertificatesModule,
    PersonalParamsRoutingModule,
    CertificatesRoutingModule,
    COCRoutingModule,
    PlacaRoutingModule,
    AppRoutingModule,
    NgbModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    interceptorProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpSizeInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
